import React from "react";
import "./style.css";

import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import { SuccessIcon } from "../../../Assets/images/svgs";

const SuccessPopupModal = ({ open, modalMsg, closeBtn="Close", onModalClose, modalSize }) => {

  const { onClose } = useDisclosure();

  const handleModalClose = () => {
    onClose();
    onModalClose();
  };

  return (
    <div>
      <Modal isOpen={open} onClose={handleModalClose} isCentered size={modalSize || "xl"}>
        <ModalOverlay />
        <ModalContent className="success-modal-content">
          <ModalBody className="success-modal-body">
            <div className="success-modal-msg-container">
              <SuccessIcon />
              <h1 className="success-modal-msg">
                {modalMsg}
              </h1>
            </div>
          </ModalBody>

          <ModalFooter className={`success-modal-footer`}>
            {closeBtn && (
              <Button onClick={handleModalClose} className="success-modal-close-button">
                {closeBtn}
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

SuccessPopupModal.propTypes = {
  open: PropTypes.bool,
  modalSize: PropTypes.string,
  modalMsg: PropTypes.oneOfType([ PropTypes.string, PropTypes.element, PropTypes.number ]),
  closeBtn: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default SuccessPopupModal;
